module.exports = __webpack_public_path__ + "07e82c85686362f20aea6db4156c30e2.ttf";